<div class="buttons-action">
    <div class="grid grid-cols-12 pd-3 gap-x-4 gap-y-1">
        <div class="col-span-12" *ngIf="isShowMessage">
            <span [style]="styleMessage">{{message}}</span>
        </div>
        <div class="col-span-12" *ngIf="isShowMessages">
            <ng-container *ngFor="let msg of messages">
                <span [style]="styleMessage">{{msg}}</span>
            </ng-container>
        </div>
        <div class="col-span-12 md:col-span-6 align-left">
            <ng-content select="[buttons-action-left]"></ng-content>
        </div>
        <div class="col-span-12 md:col-span-6 align-right">
            <ng-content select="[buttons-action-right]"></ng-content>
        </div>
    </div>
</div>